import React, { useState } from "react"
import { Card, CardBody, Button } from "reactstrap"
import { connect } from "react-redux"
import { useWallet } from "../libs/useMetaMaskWallet"
import { setNetworkOption, setToastMessage, setNetwork } from "../store/common/commonActions"
import MetamaskLogo from "../assets/images/metamask.png"
import { ChainUnsupportedError } from "../libs/useMetaMaskWallet/error"
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core"

const LoginToMetamask = (props) => {
    const {
        setNetworkOption,
        setToastMessage,
        setNetwork
    } = props

    const wallet = useWallet()
    const [openInstallMetaMaskDialog, setOpenInstallMetaMaskDialog] = useState(false)

    const handleConnect = async () => {
        setNetworkOption("")
        setNetwork("Metamask")
        try {
            await wallet.connect()
            if (wallet.error && wallet.error.name === "NoEthereumProviderError") {
                setOpenInstallMetaMaskDialog(true)
            }
        } catch (error) {
            setNetworkOption("Ethereum")
            if (error instanceof ChainUnsupportedError) {
                console.log(error.message)
                setToastMessage("error", error.message)
            } else {
                console.error(error)
                setOpenInstallMetaMaskDialog(true)
            }
        }
    }

    const goToInstallMetaMaskPage = () => {
        window.open("https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn", "_blank")
        setOpenInstallMetaMaskDialog(false)
    }

    return (
        <React.Fragment>
            <div className="content trading-page">
                <Card>
                    <CardBody>
                        <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                            <div className="metamask_logo">
                                <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                            </div>
                            <h1 className="mt-4">Connect Wallet</h1>
                            <p>
                                Connecting you Ethereum and the Decentralized Web.
                                <br />
                                We're happy to see you.
                            </p>
                            <Button color="primary" className="waves-effect waves-light" style={{ width: 200 }} onClick={() => handleConnect()}>
                                Connect
                            </Button>
                        </div>
                    </CardBody>
                </Card>
                <Dialog
                    open={openInstallMetaMaskDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="sm"
                    fullWidth
                    onClose={() => setOpenInstallMetaMaskDialog(false)}
                >
                    <DialogTitle id="alert-dialog-title">Install MetaMask</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">Please install MetaMask wallet on your browser to connect</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" autoFocus onClick={goToInstallMetaMaskPage}>
                            {" "}
                            Install MetaMask{" "}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </React.Fragment>
    )
}

const mapDispatchToProps = {
    setNetworkOption,
    setToastMessage,
    setNetwork
}

export default connect(null, mapDispatchToProps)(LoginToMetamask)
